import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import ConnectCardIcon from '@mui/icons-material/DescriptionOutlined';
import DragIcon from '@mui/icons-material/DragIndicatorOutlined';
import LinkIcon from '@mui/icons-material/Link';
import MoreIcon from '@mui/icons-material/MoreHorizOutlined';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import IconButton from 'components/IconButton/IconButton';
import {
  bindMenu,
  bindTrigger,
  usePopupState,
} from 'material-ui-popup-state/hooks';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    backgroundColor: theme.palette.background.paper,
    marginRight: 4,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid',
    borderColor: theme.palette.grey['400'],
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1),
    minWidth: 0,
    flex: 1,
    transition: 'all .3s ease',
    '&.selected': {
      borderColor: theme.palette.primary.main,
    },
  },
  dragHandle: {
    cursor: 'move',
  },
}));

const SortableConnectCard = ({ data, index, onEdit, onDelete }) => {
  const classes = useStyles();
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: data.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'actions',
  });

  const handleDelete = () => {
    popupState.close();
    onDelete(data);
  };

  const handleConfigure = () => {
    popupState.close();
    onEdit(data);
  };

  const name = data.card?.card_name || data.overlay_text;

  return (
    <Box
      style={style}
      index={index}
      {...attributes}
      ref={setNodeRef}
      display="flex"
      alignItems="center"
    >
      <Box key={data.id} className={classes.root} mb={1}>
        <Box className={classes.container}>
          {data.card ? (
            <ConnectCardIcon sx={{ color: '#F17676' }} fontSize="small" />
          ) : (
            <LinkIcon sx={{ color: '#894FE8' }} />
          )}
          <Box ml={1} flex={1} overflow="hidden">
            <Typography>{name}</Typography>
          </Box>
          <Box>
            <IconButton
              size="small"
              edge="end"
              icon={<MoreIcon />}
              {...bindTrigger(popupState)}
            />
            <Menu {...bindMenu(popupState)}>
              <MenuItem onClick={handleConfigure}>Edit</MenuItem>
              <Divider />
              <MenuItem onClick={handleDelete}>Delete</MenuItem>
            </Menu>
          </Box>
        </Box>
      </Box>
      <DragIcon {...listeners} className={classes.dragHandle} />
    </Box>
  );
};

export default SortableConnectCard;
